


/*
 * KitchenCraftSA — MistFlow Gift Packaging V7
 * Amose Cart Drawer Integration
 * Light Gold Rounded Design
 */

(() => {
  if (window.KCMistflowGiftV7) return;
  window.KCMistflowGiftV7 = true;

  const MISTFLOW_ID = 9339215380718;
  const GIFT_ID = 49819727429870;
  const PRICE = 15;
  const ROOT = window.Shopify?.routes?.root || '/';

  let mistflows = 0;
  let savedBoxes = 0;
  let selectedBoxes = 1;
  let selected = false;
  let expanded = false;
  let editing = false;
  let busy = false;
  let syncing = false;
  let ready = false;
  let refreshPending = false;

  const $ = (selector, root = document) =>
    root.querySelector(selector);

  function money(qty) {
    return `R${(qty * PRICE).toFixed(2)}`;
  }

  async function api(path, payload) {
    const response = await fetch(ROOT + path, {
      method: payload === undefined ? 'GET' : 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: payload === undefined
        ? {}
        : { 'Content-Type': 'application/json' },
      body: payload === undefined
        ? undefined
        : JSON.stringify(payload)
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data.description ||
        data.message ||
        'Cart update failed.'
      );
    }

    return data;
  }

  function getMistflows(cart) {
    return cart.items
      .filter(item =>
        Number(item.product_id) === MISTFLOW_ID
      )
      .reduce((sum, item) => sum + item.quantity, 0);
  }

  function getGiftLines(cart) {
    return cart.items.filter(item =>
      Number(item.variant_id) === GIFT_ID
    );
  }

  function getBoxes(cart) {
    return getGiftLines(cart)
      .reduce((sum, item) => sum + item.quantity, 0);
  }

  function target() {
    return $('.amose-cart-drawer-total');
  }

  function installStyles() {
    if ($('#kc-gift-styles')) return;

    const style = document.createElement('style');
    style.id = 'kc-gift-styles';

    style.textContent = `
      #kc-gift-widget {
        margin: 10px 0 14px;
        border: 2px solid #E6C878;
        border-radius: 12px;
        background: #FFFEFA;
        color: #222;
        font-family: inherit;
        overflow: hidden;
        box-shadow: 0 2px 8px rgba(183,149,66,0.10);
      }

      #kc-gift-widget[hidden],
      #kc-gift-body[hidden],
      #kc-gift-options[hidden],
      #kc-gift-save[hidden] {
        display: none !important;
      }

      #kc-gift-toggle {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 13px;
        background: #FFFEFA;
        border: 0;
        color: #222;
        text-align: left;
        cursor: pointer;
        font: inherit;
      }

      .kc-gift-title {
        font-size: 14px;
        font-weight: 700;
      }

      .kc-gift-subtitle {
        display: block;
        margin-top: 3px;
        font-size: 11px;
        color: #777;
      }

      #kc-gift-arrow {
        font-size: 20px;
        color: #B79542;
      }

      #kc-gift-body {
        border-top: 1px solid #F0E1BA;
        padding: 13px;
        font-size: 13px;
        background: #FFFEFA;
      }

      .kc-gift-check {
        display: flex;
        align-items: center;
        gap: 9px;
        cursor: pointer;
      }

      .kc-gift-check input {
        width: 17px;
        height: 17px;
        accent-color: #B79542;
      }

      #kc-gift-options {
        margin-top: 13px;
      }

      .kc-gift-description {
        font-size: 11px;
        line-height: 1.5;
        color: #777;
        margin: 7px 0 10px;
      }

      .kc-gift-qtyrow {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 10px 0;
      }

      .kc-gift-counter {
        display: flex;
        align-items: center;
        gap: 13px;
      }

      .kc-gift-counter button {
        width: 32px;
        height: 32px;
        border: 1px solid #E6C878;
        border-radius: 7px;
        background: #FFF9EB;
        color: #222;
        font-size: 19px;
        cursor: pointer;
      }

      .kc-gift-counter button:disabled {
        opacity: .35;
        cursor: not-allowed;
      }

      #kc-gift-save {
        width: 100%;
        margin-top: 13px;
        padding: 11px;
        border: 0;
        border-radius: 8px;
        background: #171717;
        color: #fff;
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
      }

      #kc-gift-save:disabled {
        opacity: .5;
      }

      #kc-gift-message {
        margin: 8px 0 0;
        font-size: 12px;
        line-height: 1.4;
      }
    `;

    document.head.appendChild(style);
  }

  function createWidget() {
    const widget = document.createElement('div');
    widget.id = 'kc-gift-widget';

    widget.innerHTML = `
      <button
        type="button"
        id="kc-gift-toggle"
        aria-expanded="false"
      >
        <span>
          <span
            class="kc-gift-title"
            id="kc-gift-title"
          >
            🎁 Is the MistFlow a Gift?
          </span>

          <span class="kc-gift-subtitle">
            Upgrade to gift packaging for R15 per box
          </span>
        </span>

        <span id="kc-gift-arrow">⌄</span>
      </button>

      <div id="kc-gift-body" hidden>
        <label class="kc-gift-check">
          <input
            type="checkbox"
            id="kc-gift-check"
          >
          Yes, add gift packaging
        </label>

        <div id="kc-gift-options" hidden>
          <div>How many gift boxes?</div>

          <p class="kc-gift-description">
            Your MistFlow will arrive in the gift box
            shown next to the bottle in our product photos,
            instead of our standard packaging.
            No gift wrapping.
          </p>

          <div class="kc-gift-qtyrow">
            <div class="kc-gift-counter">
              <button
                type="button"
                id="kc-gift-minus"
              >−</button>

              <strong id="kc-gift-qty">1</strong>

              <button
                type="button"
                id="kc-gift-plus"
              >+</button>
            </div>

            <strong id="kc-gift-price">R15.00</strong>
          </div>
        </div>

        <button
          type="button"
          id="kc-gift-save"
          hidden
        >
          Add Gift Boxes
        </button>

        <p id="kc-gift-message" role="status"></p>
      </div>
    `;

    $('#kc-gift-toggle', widget)
      .addEventListener('click', () => {
        expanded = !expanded;
        render();
      });

    $('#kc-gift-check', widget)
      .addEventListener('change', event => {
        selected = event.target.checked;
        editing = true;

        if (selected && selectedBoxes < 1) {
          selectedBoxes = 1;
        }

        render();
      });

    $('#kc-gift-minus', widget)
      .addEventListener('click', () => {
        selectedBoxes = Math.max(
          1,
          selectedBoxes - 1
        );

        editing = true;
        render();
      });

    $('#kc-gift-plus', widget)
      .addEventListener('click', () => {
        selectedBoxes = Math.min(
          mistflows,
          selectedBoxes + 1
        );

        editing = true;
        render();
      });

    $('#kc-gift-save', widget)
      .addEventListener('click', save);

    return widget;
  }

  function ensureWidget() {
    const total = target();
    if (!total) return null;

    let widget = $('#kc-gift-widget');

    if (!widget || widget.nextElementSibling !== total) {
      if (widget) widget.remove();

      widget = createWidget();

      total.insertAdjacentElement(
        'beforebegin',
        widget
      );
    }

    return widget;
  }

  function showMessage(message, error = false) {
    const widget = ensureWidget();
    if (!widget) return;

    const element = $('#kc-gift-message', widget);
    element.textContent = message;

    element.style.color = error
      ? '#b42318'
      : '#277044';
  }

  function render() {
    const widget = ensureWidget();
    if (!widget) return;

    widget.hidden = mistflows === 0;

    selectedBoxes = Math.max(
      1,
      Math.min(selectedBoxes, mistflows || 1)
    );

    $('#kc-gift-title', widget).textContent =
      mistflows === 1
        ? '🎁 Is the MistFlow a Gift?'
        : '🎁 Are the MistFlows Gifts?';

    $('#kc-gift-body', widget).hidden = !expanded;

    $('#kc-gift-toggle', widget)
      .setAttribute(
        'aria-expanded',
        String(expanded)
      );

    $('#kc-gift-arrow', widget).textContent =
      expanded ? '⌃' : '⌄';

    const checkbox = $('#kc-gift-check', widget);
    checkbox.checked = selected;
    checkbox.disabled = busy;

    $('#kc-gift-options', widget).hidden = !selected;

    $('#kc-gift-qty', widget).textContent =
      selectedBoxes;

    $('#kc-gift-price', widget).textContent =
      money(selectedBoxes);

    $('#kc-gift-minus', widget).disabled =
      busy || selectedBoxes <= 1;

    $('#kc-gift-plus', widget).disabled =
      busy || selectedBoxes >= mistflows;

    const saveButton = $('#kc-gift-save', widget);

    saveButton.hidden =
      !selected && savedBoxes === 0;

    saveButton.disabled = busy;

    saveButton.textContent = busy
      ? 'Updating cart...'
      : !selected
        ? 'Remove Gift Boxes'
        : savedBoxes > 0
          ? 'Update Gift Boxes'
          : 'Add Gift Boxes';

    updateAmoseButton();
  }

  function findGiftRow() {
    const buttons = document.querySelectorAll(
      '.amose-cart-drawer-qty-btn[data-action="increase"]'
    );

    for (const button of buttons) {
      const row = button.closest(
        '.amose-cart-drawer-item'
      );

      if (
        row &&
        row.textContent.includes('MistFlow Gift Box')
      ) {
        return { row, button };
      }
    }

    return null;
  }

  function updateAmoseButton() {
    const found = findGiftRow();
    if (!found) return;

    const blocked =
      mistflows === 0 ||
      savedBoxes >= mistflows;

    found.button.disabled = blocked;

    found.button.setAttribute(
      'aria-disabled',
      String(blocked)
    );

    found.button.style.opacity =
      blocked ? '0.3' : '1';

    found.button.style.cursor =
      blocked ? 'not-allowed' : 'pointer';

    found.button.style.pointerEvents =
      blocked ? 'none' : 'auto';
  }

  async function refreshAmose() {
    if (refreshPending) return;

    const drawer = window.AmoseCartDrawer;

    if (
      !drawer ||
      typeof drawer.refresh !== 'function'
    ) {
      return;
    }

    refreshPending = true;

    try {
      await drawer.refresh();
    } catch (error) {
      console.error(
        'Amose drawer refresh failed:',
        error
      );
    } finally {
      refreshPending = false;
    }
  }

  function notifyCart(cart) {
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: {
          source: 'mistflow-gift',
          cart
        }
      })
    );

    refreshAmose();
  }

  async function setGiftQuantity(cart, wanted) {
    const lines = getGiftLines(cart);

    for (let i = lines.length - 1; i >= 1; i--) {
      await api('cart/change.js', {
        id: lines[i].key,
        quantity: 0
      });
    }

    if (lines.length > 0) {
      await api('cart/change.js', {
        id: lines[0].key,
        quantity: wanted
      });
    } else if (wanted > 0) {
      await api('cart/add.js', {
        items: [{
          id: GIFT_ID,
          quantity: wanted,
          properties: {
            'Gift packaging': 'MistFlow'
          }
        }]
      });
    }

    return api('cart.js');
  }

  async function enforceLimit(cart) {
    const max = getMistflows(cart);
    const count = getBoxes(cart);

    if (count <= max) {
      return {
        cart,
        corrected: false
      };
    }

    const correctedCart = await setGiftQuantity(
      cart,
      max
    );

    return {
      cart: correctedCart,
      corrected: true
    };
  }

  async function sync() {
    if (syncing || busy || !target()) return;

    syncing = true;

    try {
      let cart = await api('cart.js');

      const result = await enforceLimit(cart);
      cart = result.cart;

      const newMistflows = getMistflows(cart);
      const newBoxes = getBoxes(cart);

      const boxesChanged =
        ready && newBoxes !== savedBoxes;

      mistflows = newMistflows;
      savedBoxes = newBoxes;

      if (!ready) {
        selected = newBoxes > 0;
        selectedBoxes = newBoxes || 1;
        editing = false;
        ready = true;
      } else if (boxesChanged && !editing) {
        selected = newBoxes > 0;
        selectedBoxes = newBoxes || 1;
      }

      selectedBoxes = Math.min(
        selectedBoxes,
        mistflows || 1
      );

      render();

      if (result.corrected) {
        notifyCart(cart);
      }

    } catch (error) {
      console.error(
        'MistFlow gift sync error:',
        error
      );
    } finally {
      syncing = false;
    }
  }

  async function save() {
    if (busy) return;

    busy = true;
    render();
    showMessage('');

    try {
      let cart = await api('cart.js');

      const max = getMistflows(cart);

      const wanted = selected
        ? Math.min(selectedBoxes, max)
        : 0;

      if (selected && max === 0) {
        throw new Error(
          'Please add a MistFlow before selecting gift packaging.'
        );
      }

      cart = await setGiftQuantity(
        cart,
        wanted
      );

      const actual = getBoxes(cart);

      if (actual !== wanted) {
        throw new Error(
          'Gift-box quantity could not be updated. Please try again.'
        );
      }

      mistflows = getMistflows(cart);
      savedBoxes = actual;

      selected = actual > 0;
      selectedBoxes = actual || 1;

      editing = false;
      expanded = false;
      ready = true;

      busy = false;
      render();

      notifyCart(cart);

    } catch (error) {
      busy = false;
      render();

      showMessage(
        error.message ||
        'Unable to update gift boxes.',
        true
      );

      console.error(
        'Gift packaging update:',
        error
      );
    }
  }

  document.addEventListener('click', event => {
    const button = event.target.closest?.(
      '.amose-cart-drawer-qty-btn[data-action="increase"]'
    );

    if (!button) return;

    const row = button.closest(
      '.amose-cart-drawer-item'
    );

    if (
      !row ||
      !row.textContent.includes('MistFlow Gift Box')
    ) {
      return;
    }

    if (savedBoxes >= mistflows) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  function start() {
    installStyles();

    setInterval(() => {
      if (!target() || busy) return;

      ensureWidget();
      updateAmoseButton();
      sync();
    }, 1200);

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start
    );
  } else {
    start();
  }
})();


